module.exports = __webpack_public_path__ + "static/media/menu.c6ce22fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/menu.svg
// module id = 474
// module chunks = 40